import './MenuNav.scss';
import { Link, useLocation } from "react-router-dom";

function MenuNav() {

    const location = useLocation();

    return (
        <nav className="menu-nav">
            <Link
                to="/menu/cakes"
                className={`${location.pathname === '/menu/cakes' ? 'active' : ''}`}>
                Cakes
            </Link>
            <span className="pipe">|</span>
            <Link
                to="/menu/cupcakes"
                className={`${location.pathname === '/menu/cupcakes' ? 'active' : ''}`}>
                Cupcakes
            </Link>
            <span className="pipe">|</span>
            <Link
                to="/menu/cookies"
                className={`${location.pathname === '/menu/cookies' ? 'active' : ''}`}>
                Cookies
            </Link>
            <span className="pipe">|</span>
            <Link
                to="/menu/cakesicles"
                className={`${location.pathname === '/menu/cakesicles' ? 'active' : ''}`}>
                Cakesicles
            </Link>
            <span className="pipe">|</span>
            <Link
                to="/menu/tarts-bars-brownies"
                className={`${location.pathname === '/menu/tarts-bars-brownies' ? 'active' : ''}`}>
                Tarts, Bars, Brownies
            </Link>
        </nav>
    )
}

export default MenuNav;